export const APP_WIDTH = 1200
export const APP_HEIGHT = 675

export const PLAYER_FRICTION = 0.02
export const GRAVITY = 0.01

export const DUST_COUNT = 500
export const DUST_SPEED = 0.5

export const TERRAIN_TILE_WIDTH = 3400
export const TERRAIN_TILE_HEIGHT = 800
export const TERRAIN_TILE_COUNT = 3

export const KELP_N_FRAMES = 16
export const STATIC_N_FRAMES = 7

export const BULLET_DESPAWN_DISTANCE_FROM_PLAYER = 1000

export const N_UPGRADES = 3
